import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import FormFields from "../components/FormFields";
import { useTournamentStateContext } from "../data/providers/TournamentStateProvider";
import tournamentConfig from "../data/tournamentConfig";
import { FormDataType } from "../types";
import { constructEmptyForm } from "../utils/constructEmptyForm";
import { useNavigateOn404 } from "../utils/useNavigateOn404";
export const EditTournamentPage = () => {
  const { tournamentState, setTournamentById } = useTournamentStateContext();
  const navigateOn404 = useNavigateOn404();

  const { tournamentId } = useParams();

  const [formData, setFormData] = useState<FormDataType>(
    constructEmptyForm(tournamentConfig.createAndEditFields)
  );

  useEffect(() => {
    navigateOn404(async () => {
      const id = parseInt(tournamentId ?? "");
      await setTournamentById(id);
    });
  }, [tournamentId]);

  useEffect(() => {
    setFormData(
      tournamentConfig.createAndEditFields.reduce(
        (prev, field) => ({
          ...prev,
          [field.fieldName]:
            tournamentState[field.fieldName as keyof typeof tournamentState] ??
            formData[field.fieldName],
          id: tournamentState.id,
        }),
        {}
      )
    );
  }, [tournamentId, tournamentState]);

  return (
    <div className="ticketCategoryPageWrapper">
      <h5 className="ticketCategoryPageTitle">General Information</h5>

      <FormFields
        fields={tournamentConfig.createAndEditFields}
        form={{ method: "edit", data: formData }}
        setFormData={(_, data) => setFormData(data)}
        formMode="edit"
        name={tournamentConfig.name}
        onCreateFunction={tournamentConfig.onCreate}
        onUpdateFunction={tournamentConfig.onUpdate}
      />
    </div>
  );
};
